import React from 'react';
import PropTypes from 'prop-types';
import Favicon from 'react-favicon';

import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { ActionCodeOperation } from 'firebase/auth';

import { SYSTEM_RESOURCE } from '../../constants/EndPoints';
import * as misc from '../../constants/Misc';

import './Login.scss';

function parseQuery(location) {
  const query = (location && location.query) || {};
  const search = (location && location.search) || '';
  const params = new URLSearchParams(search);

  return {
    mode: query.mode || params.get('mode') || '',
  };
}

function normalizeMode(mode) {
  switch (mode) {
    case ActionCodeOperation.VERIFY_EMAIL:
    case 'verifyEmail':
      return 'verifyEmail';
    case ActionCodeOperation.PASSWORD_RESET:
    case 'resetPassword':
      return 'resetPassword';
    case ActionCodeOperation.RECOVER_EMAIL:
    case 'recoverEmail':
      return 'recoverEmail';
    case ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION:
    case 'revertSecondFactorAddition':
      return 'revertSecondFactorAddition';
    default:
      return mode;
  }
}

function buildTargetPath(mode, search) {
  const normalizedMode = normalizeMode(mode);

  if (normalizedMode === 'verifyEmail') {
    return `/${misc.routes.VERIFY_EMAIL}${search || ''}`;
  }

  if (normalizedMode === 'resetPassword') {
    return `/${misc.routes.RESET_PASSWORD_CONFIRM}${search || ''}`;
  }

  if (normalizedMode === 'recoverEmail') {
    return `/${misc.routes.RECOVER_EMAIL}${search || ''}`;
  }

  if (normalizedMode === 'revertSecondFactorAddition') {
    return `/${misc.routes.RESET_MFA}${search || ''}`;
  }

  return null;
}

function FirebaseActionLanding(props) {
  const [error, setError] = React.useState('');
  const sys = SYSTEM_RESOURCE;
  const location = (props && props.location) || window.location;
  const query = parseQuery(location);
  const systemName = process.env.REACT_APP_SYSTEM_NAME;
  const backgroundImagePath = require(`../../../images/system/${sys}/login_bg.png`);

  const mainStyle = {
    backgroundImage: `url(${backgroundImagePath})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  React.useEffect(
    function () {
      const target = buildTargetPath(query.mode, location.search);

      if (!target) {
        setError('This email link is not supported by this page.');
        return;
      }

      window.location.replace(target);
    },
    [location.search, query.mode]
  );

  return (
    <section className='page login-page mfa-confirm-removal-page'>
      <Favicon url={require(`./../../../images/system/${sys}/favicon_1.png`)} />

      <div className='main' style={mainStyle}>
        <div className='login-form form-horizontal'>
          <header>
            <div className='logo'>{systemName}</div>
            <div className='version'>
              {`v.`} <strong>{misc.versionNumber}</strong>
            </div>
          </header>

          <h2 className='mfa-confirm-title'>Confirm email action</h2>

          {error ? (
            <Alert severity='error' className='mfa-confirm-alert'>
              {error}
            </Alert>
          ) : (
            <div className='mfa-confirm-loading'>
              <CircularProgress size={24} />
              <span>Preparing your confirmation page...</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

FirebaseActionLanding.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.object,
    search: PropTypes.string,
  }),
};

export default FirebaseActionLanding;
